import * as layout from "../../routes/$layout.js";
export { layout };
export { default as ErrorComponent } from "../components/error.js";

export const components = [
	() => import("../../routes/index.js"),
	() => import("../../routes/products/viewAlphaFly.js"),
	() => import("../../routes/products/list.js"),
	() => import("../../routes/products/view.js"),
	() => import("../../routes/orders/index.js"),
	() => import("../../routes/cart/index.js"),
	() => import("../../routes/cart/checkout.js")
];

export const routes = [
	{
		// index.svelte
		pattern: /^\/$/,
		parts: [
			{ i: 0 }
		]
	},

	{
		// products/viewAlphaFly.svelte
		pattern: /^\/products\/viewAlphaFly\/?$/,
		parts: [
			null,
			{ i: 1 }
		]
	},

	{
		// products/list.svelte
		pattern: /^\/products\/list\/?$/,
		parts: [
			null,
			{ i: 2 }
		]
	},

	{
		// products/view.svelte
		pattern: /^\/products\/view\/?$/,
		parts: [
			null,
			{ i: 3 }
		]
	},

	{
		// orders/index.svelte
		pattern: /^\/orders\/?$/,
		parts: [
			{ i: 4 }
		]
	},

	{
		// cart/index.svelte
		pattern: /^\/cart\/?$/,
		parts: [
			{ i: 5 }
		]
	},

	{
		// cart/checkout.svelte
		pattern: /^\/cart\/checkout\/?$/,
		parts: [
			null,
			{ i: 6 }
		]
	}
];